import { ArticleModel } from "../archive/article.model";

export class PurchaseProjectionModel {
    purchaseProjectionId: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    articleId: number = 0;
    article: ArticleModel | null = null;
    quantity: number = 0;
    datePurchaseProjection: Date = new Date();
    createDate: Date = new Date();
    userNameCreate: string = "";
    updateDate: Date | null = null;
    userNameUpdate: string | null = null;
}
